import React from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import SkeletonLoader from '../../../elements/SkeletonLoader';
import MultiSelectDropdown from '../../../elements/MultiSelectDropdown';
import useExecutionScope from '../../../../hooks/useExecutionScope';
import { useParams } from 'react-router-dom';
import ExecutionScopeForm from '../../../elements/common/execution/ExecutionScopeForm';

const TestCycleFilterForm = ({
  formData,
  setFormData,
  statuses = [],
  purposeOptions = [],
  typeOptions = [],
  projectUsers = [],
  loading,
}) => {
  // const handleChange = (e) => {
  //   const { id, value, type, checked } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [id]: type === 'checkbox' ? checked : value,
  //   }));
  // };
    const { projectId } = useParams();
  const { isScopeDefined } = useExecutionScope(projectId);

  const projectUserOptions = projectUsers.map((user) => ({
    id: user.id,
    name: user.full_name,
  }));

const handleDropdownChange = (id, value) => {
    let newValue = value;
    if (id === 'owner') {
      newValue = Array.isArray(value) ? value : [];
    } else {
      newValue = value === '' ? null : value;
    }

    setFormData((prevData) => ({
      ...prevData,
      [id]: newValue,
    }));
  };
    const handleAdvanceFilters = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };
  return (
    <div>
      {loading ? (
        <SkeletonLoader />
      ) : (
        <Form>
          <Container fluid className="p-0">
            <Row className="mt-2">
              <Col md={6}>
                <Form.Group controlId="status">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    as="select"
                    value={formData.status}
                    onChange={(e) =>
                      handleDropdownChange('status', e.target.value)
                    }
                    className="form-input">
                    <option value="All">All</option>
                    {statuses?.map((status) => (
                      <option key={status.id} value={status.id}>
                        {status.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="owner">
                  <Form.Label>Owner</Form.Label>
                  <MultiSelectDropdown
                    options={projectUserOptions}
                    selectedValues={formData?.owner || []}
                    maxSelections={projectUserOptions?.length}
                    onChange={(selectedValues) =>
                      handleDropdownChange('owner', selectedValues)
                    }
                    placeholder=""
                    name='users'
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col md={6}>
                <Form.Group controlId="purpose">
                  <Form.Label>Purpose</Form.Label>
                  <Form.Select
                    as="select"
                    required
                    value={formData.purpose || ''}
                    onChange={(e) =>
                      handleDropdownChange('purpose', e.target.value)
                    }
                    className="form-input">
                    <option value="All">All</option>
                    {purposeOptions?.map((purpose) => (
                       <option key={purpose.id} value={purpose.id}>
                        {purpose.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId="type">
                  <Form.Label>Test Cycle Type</Form.Label>
                  <Form.Select
                    as="select"
                    value={formData.type}
                    onChange={(e) =>
                      handleDropdownChange('type', e.target.value)
                    }
                    className="form-input">
                    <option value="All">All</option>
                    {typeOptions?.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
              {isScopeDefined && (
              <>
                <hr />
                <ExecutionScopeForm
                  values={formData}
                  setFieldValue={handleAdvanceFilters}
                  isPlatformRequired={false}
                />
              </>
            )}
          </Container>
        </Form>
      )}
    </div>
  );
};

export default TestCycleFilterForm;